import React from 'react';
import { SVGIconProps } from '../../domains/common';

const LinkedinIcon: React.FC<SVGIconProps> = ({ colored, ...rest }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1904_58039)">
        <path
          d="M0 1.71919C0 0.77025 0.794437 0 1.77375 0H22.2263C23.2059 0 24 0.77025 24 1.71919V22.2811C24 23.2303 23.2059 24 22.2263 24H1.77375C0.794531 24 0 23.2304 0 22.2814V1.71891V1.71919Z"
          fill={colored ? '#069' : '#365284'}
        />
        <path
          d="M7.2933 20.0848V9.27994H3.70192V20.0848H7.29367H7.2933ZM5.49836 7.80497C6.75048 7.80497 7.53002 6.97528 7.53002 5.9384C7.50658 4.8779 6.75048 4.07137 5.52217 4.07137C4.29302 4.07137 3.49023 4.8779 3.49023 5.93831C3.49023 6.97519 4.26948 7.80487 5.47483 7.80487H5.49808L5.49836 7.80497ZM9.28117 20.0848H12.8723V14.0515C12.8723 13.729 12.8957 13.4057 12.9906 13.1753C13.2501 12.5299 13.841 11.8617 14.8333 11.8617C16.1325 11.8617 16.6525 12.8525 16.6525 14.3051V20.0848H20.2435V13.8896C20.2435 10.571 18.472 9.02662 16.1093 9.02662C14.1721 9.02662 13.3213 10.1093 12.8486 10.8468H12.8725V9.28031H9.28136C9.32823 10.2939 9.28108 20.0852 9.28108 20.0852L9.28117 20.0848Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1904_58039">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LinkedinIcon;
